import React from 'react';
import './AdminFooter.css';

const AdminFooter = () => {
    return (
        <footer className="admin-footer-layout">
            <div className="admin-footer-layout-container">
                <div className="admin-footer-layout-right">
                    <p>
                        Developed & Designed With <span className="admin-footer-layout-heart">❤️</span> By 
                        <a 
                            href="https://dheersoftwaresolutions.com" 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="admin-footer-layout-link"
                        >
                            Dheer Software Solutions
                        </a>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default AdminFooter;